import { createI18n } from "vue-i18n";
import tr from "@/locales/tr.json";
import en from "@/locales/en.json";

const saved = localStorage.getItem("lang");

export const i18n = createI18n({
  legacy: false,              // script setup için önerilen
  locale: saved || "tr",
  fallbackLocale: "en",
  messages: { tr, en },
});

export function setLanguage(lang) {
  i18n.global.locale.value = lang;
  localStorage.setItem("lang", lang);
}
